/**
 * Navigation bar component
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';
import { Container } from '../ui/Container';
import { getBillingState } from '../../services/billing/local-billing';

/**
 * Navigation component
 */
export const Navigation: React.FC = () => {
  const { subscribed, purchasedCourseIds } = getBillingState();
  const hasAnyPaidCourse = subscribed || purchasedCourseIds.length > 0;
  
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-brand-dark/95 backdrop-blur-sm border-b border-brand-gray-800">
      <Container>
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <span className="text-2xl font-bold text-white">
              Master <span className="text-brand-gold">Polyglots</span>
            </span>
          </Link>
          
          {/* Navigation Links */}
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/courses"
              className="text-gray-300 hover:text-white transition-colors duration-200"
            >
              Explore Courses
            </Link>
            <Link
              to="/instructors"
              className="text-gray-300 hover:text-white transition-colors duration-200"
            >
              Instructors
            </Link>
            <Link
              to="/about"
              className="text-gray-300 hover:text-white transition-colors duration-200"
            >
              About
            </Link>
          </div>
          
          {/* Auth Buttons */}
          <div className="flex items-center space-x-4">
            {hasAnyPaidCourse ? (
              <Link to="/my-courses">
                <Button variant="outline" size="sm">
                  My Courses
                </Button>
              </Link>
            ) : (
              <Link to="/courses">
                <Button variant="gold" size="sm">
                  Browse Courses
                </Button>
              </Link>
            )}
          </div>
        </div>
      </Container>
    </nav>
  );
};
